export const isCrediMart = () =>
  process.env.NEXT_PUBLIC_APP_NAME === "credimart";
export const isCrediStore = () =>
  process.env.NEXT_PUBLIC_APP_NAME === "credistore";
export const normalizeUrl = (url) => url.split("?")[0];
